import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { CreditCard, Lock } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { Button } from "@/components/ui/button";

let methodsCache = null;
export const isTrialEligible = (user) => !!user && user.role !== "owner" && !user.trial_used && (user.plan || "free") === "free";

export async function startCheckout(provider, lookup_key) {
  const path = provider === "paypal" ? "/payments/paypal/subscribe" : "/payments/checkout";
  const r = await api.post(path, { lookup_key, origin_url: window.location.origin });
  window.location.href = r.data.checkout_url;
}

function PayPalMark() {
  return <span className="font-display font-extrabold italic tracking-tight"><span className="text-[#003087] dark:text-[#9cc3ff]">Pay</span><span className="text-[#009cde]">Pal</span></span>;
}

export function PayButtons({ lookupKey, trial, testPrefix = "pay" }) {
  const [busy, setBusy] = useState(null);
  const [paypal, setPaypal] = useState(methodsCache ? methodsCache.paypal : false);
  useEffect(() => {
    if (methodsCache) { return; }
    api.get("/payments/methods").then((r) => { methodsCache = r.data; setPaypal(r.data.paypal); }).catch(() => {});
  }, []);
  const go = async (provider) => {
    setBusy(provider);
    try { await startCheckout(provider, lookupKey); }
    catch (e) { toast.error(formatErr(e.response?.data?.detail)); setBusy(null); }
  };
  return (
    <div className="space-y-2">
      <Button data-testid={`${testPrefix}-card-btn`} disabled={!!busy} onClick={() => go("stripe")}
        className="w-full h-11 bg-indigo-600 hover:bg-indigo-500 text-white font-semibold">
        <CreditCard className="h-4 w-4 mr-2" />{busy === "stripe" ? "Opening secure checkout…" : trial ? "Start free trial with card" : "Pay with card"}
      </Button>
      <button data-testid={`${testPrefix}-paypal-btn`} disabled={!!busy || !paypal} onClick={() => go("paypal")}
        className="w-full h-11 rounded-md bg-[#ffc439] hover:bg-[#f2b92f] disabled:opacity-50 text-slate-900 font-semibold transition-colors flex items-center justify-center gap-2">
        {busy === "paypal" ? "Opening PayPal…" : paypal ? <><PayPalMark />{trial ? <span className="text-sm">· start free trial</span> : null}</> : <span className="text-sm">PayPal coming soon</span>}
      </button>
      <div className="text-[11px] text-center text-muted-foreground flex items-center justify-center gap-1">
        <Lock className="h-3 w-3" />{trial ? "$0 today · cancel before day 7 and you won't be charged" : "Secure checkout · cancel anytime"}
      </div>
    </div>
  );
}
